import { render } from "./MaterialList.vue?vue&type=template&id=15603a1e&scoped=true"
import script from "./MaterialList.vue?vue&type=script&lang=js"
export * from "./MaterialList.vue?vue&type=script&lang=js"

import "./MaterialList.vue?vue&type=style&index=0&id=15603a1e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15603a1e"]])

export default __exports__